import { useState } from 'react';

interface FormState {
	fname: string;
	lname: string;
	email: string;
	subject: string;
	message: string;
}

interface ModalState {
	open: boolean;
	success: boolean;
	message: string;
}

const emptyForm: FormState = { fname: '', lname: '', email: '', subject: '', message: '' };

function Contact() {
	const [form, setForm] = useState<FormState>(emptyForm);
	const [submitting, setSubmitting] = useState(false);
	const [modal, setModal] = useState<ModalState>({ open: false, success: true, message: '' });

	const closeModal = () => setModal((prev) => ({ ...prev, open: false }));

	const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		setForm((prev) => ({ ...prev, [e.target.id]: e.target.value }));
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setSubmitting(true);
		try {
			const res = await fetch('/api/send-email', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					name: `${form.fname} ${form.lname}`.trim(),
					email: form.email,
					subject: form.subject,
					message: form.message,
				}),
			});
			if (res.ok) {
				setModal({ open: true, success: true, message: 'Your message was sent successfully!' });
				setForm(emptyForm);
			} else {
				setModal({ open: true, success: false, message: 'Failed to send email. Please try again.' });
			}
		} catch {
			setModal({ open: true, success: false, message: 'Failed to send email. Please try again.' });
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<div id="fh5co-consult">
			{modal.open && (
				<div
					style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
					onClick={closeModal}
				>
					<div
						style={{ background: '#fff', padding: '2rem', borderRadius: '8px', maxWidth: '400px', width: '90%', textAlign: 'center', boxShadow: '0 4px 24px rgba(0,0,0,0.2)' }}
						onClick={(e) => e.stopPropagation()}
					>
						<h4 style={{ marginBottom: '0.75rem', color: modal.success ? '#27ae60' : '#e74c3c' }}>
							{modal.success ? 'Message Sent!' : 'Something went wrong'}
						</h4>
						<p style={{ marginBottom: '1.5rem', color: '#555' }}>{modal.message}</p>
						<button className="btn btn-primary" onClick={closeModal}>Close</button>
					</div>
				</div>
			)}
			<div className="video fh5co-video" style={{ backgroundImage: 'url(images/cover_bg_future.png)' }}>
				<div className="overlay"></div>
			</div>
			<div className="choose animate-box">
				<h2>Contact</h2>
				<form id="email-form" onSubmit={handleSubmit}>
					<div className="row form-group">
						<div className="col-md-6">
							<input type="text" id="fname" className="form-control" placeholder="Your first name" required value={form.fname} onChange={handleChange} />
						</div>
					</div>
					<div className="row form-group">
						<div className="col-md-6">
							<input type="text" id="lname" className="form-control" placeholder="Your last name (optional)" value={form.lname} onChange={handleChange} />
						</div>
					</div>
					<div className="row form-group">
						<div className="col-md-12">
							<input type="email" id="email" className="form-control" placeholder="Your email address (optional — needed to reply)" value={form.email} onChange={handleChange} />
						</div>
					</div>
					<div className="row form-group">
						<div className="col-md-12">
							<input type="text" id="subject" className="form-control" placeholder="Subject (optional)" value={form.subject} onChange={handleChange} />
						</div>
					</div>
					<div className="row form-group">
						<div className="col-md-12">
							<textarea id="message" cols={30} rows={10} className="form-control" placeholder="Say something" required value={form.message} onChange={handleChange}></textarea>
						</div>
					</div>
					<div className="form-group">
						<input type="submit" id="submit-button" value="Send Message" className="btn btn-primary" disabled={submitting} />
					</div>
				</form>
			</div>
		</div>
	);
}

export default Contact;
